module.exports = __webpack_public_path__ + "img/maintenance.aeb9cc5b.svg";